"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    backgroundColor: props => {
      return props.backgroundColor || theme.palette.background.default;
    },
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    "& + $root": {
      left: "100%",
      width: "50%"
    },
    "&[aria-expanded=false]": {
      right: "50%"
    },
    "&[aria-expanded=false] + $root": {
      left: "50%"
    }
  }
}));

const FinderBase = ({
  backgroundColor,
  expanded = true,
  children
}) => {
  const classes = useStyles({
    backgroundColor
  });
  return _react.default.createElement("div", {
    className: classes.root,
    "aria-expanded": expanded
  }, children);
};

var _default = FinderBase;
exports.default = _default;
module.exports = exports.default;